module.exports = __webpack_public_path__ + "static/media/fill_62@2x.3d1a71fb.png";